<template>
  <div class="navBar">
      <ul class="nav fr ac jsb">
          <li v-if="showBack" @click="$router.back(-1)" class="ico backIco"></li>
          <li v-else class="ico"></li>
          <li class="title">{{title}}</li>
          <li class="ico shareIco"></li>
      </ul>
  </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: "" 
        },
        showBack: {
            type: Boolean,
            default: true,
        }
    },
    methods: {
       
    }
}

</script>
<style lang="scss">
    .navBar {
        width: 100%;
        padding: 0 20px;
        height: 98px;
        box-sizing: border-box;
        background-color: #ec5f2a;
        position: fixed;
        top: 0;
        z-index: 10;
        font-size: 28px;
        .nav {
            height: 98px;
            .ico {
                width: 40px;
                height: 40px;
                background-size: cover;
            }
            .backIco {
                background-image: url(../../../static/imgs/navBar/back.png);
            }
            .title {
                color: #fff;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/common/navBar.vue